import React from 'react'
import { IconButton, Tooltip } from '@material-ui/core'
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';

const copy = require('clipboard-copy')


export const CopyToClipboard = ({text}) => {
    const [tooltipShow, setTooltipShow] = React.useState(false)
    const handleClose = () => setTooltipShow(false)

    const copyShareLinkToClipboard = () => {
        copy(text)
        setTooltipShow(true)
        setTimeout(() => {
            handleClose()
        }, 1000)
    }

    return (<Tooltip placement="top" title={'Copied'} open={tooltipShow} onClose={handleClose}>
                <IconButton 
                    onClick={copyShareLinkToClipboard}>
                        <FileCopyOutlinedIcon className='blue' />
                </IconButton>
            </Tooltip>)
}